module.exports = __webpack_public_path__ + "img/arm fully extended.88cef0eb.png";